import { css } from 'styled-components'

export const wrap = css`
  display: flex;
  flex-wrap: wrap;
`

export const title = css`
  cursor: pointer;
  display: flex;
  font-weight: 700;
  width: 80%;
`

export const icon = css`
  flex: none;
  margin-right: 1rem;
`

export const date = css`
  font-weight: 700;
  width: 20%;
  padding-right: 1rem;
`
